module.exports = __webpack_public_path__ + "img/1140-255-desktop.909ab45.webp";